import { useField } from 'formik';
import React from 'react';
import { FormErrorMessage } from '../../../../base-components/FormErrorMessage';
import { Region } from '../../../../types/entities';
import styles from './FormSelectRegion.module.scss';
import { SelectRegion } from './SelectRegion';

interface Props {
    name: string;
    regions: Region[];
    className?: string;
}

/**
 * Селектор региона
 */
export const FormSelectRegion: React.FC<Props> = ({
    name,
    regions,
    className,
}) => {
    const [field, , helpers] = useField(name);

    return (
        <div className={className}>
            <SelectRegion
                instanceId={name}
                regions={regions}
                onChange={helpers.setValue}
                value={field.value}
                className={styles.field}
            />
            <FormErrorMessage name={name} />
        </div>
    );
};
